/**
 * Magnifying Glass Image Zoom Effect (Follows Mouse Direction)
 * Uses GPU-accelerated CSS transforms for high performance and reliability.
 */

(function() {
  function handleZoom(e) {
    const container = e.target.closest('.product-media-container, modal-opener, .product__modal-opener, .product__media');
    if (!container) return;

    const img = container.querySelector('.image-magnify-hover');
    if (!img) return;

    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    let xPercent = (x / rect.width) * 100;
    let yPercent = (y / rect.height) * 100;

    xPercent = Math.max(0, Math.min(100, xPercent));
    yPercent = Math.max(0, Math.min(100, yPercent));

    container.style.overflow = 'hidden';
    img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    img.style.transform = 'scale(2.2)';
    img.style.transition = 'transform 0.15s ease-out';
  }

  function handleReset(e) {
    const container = e.target.closest('.product-media-container, modal-opener, .product__modal-opener, .product__media');
    if (!container) return;

    if (e.relatedTarget && container.contains(e.relatedTarget)) return;

    const img = container.querySelector('.image-magnify-hover');
    if (img) {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    }
  }

  document.addEventListener('mousemove', handleZoom, { passive: true });
  document.addEventListener('mouseout', handleReset, { passive: true });
})();
